exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-header-title[data-v-1f7b81f4] {\n  color: #111;\n  font-size: 18px;\n  font-weight: 600;\n}\n.block-list[data-v-1f7b81f4] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  padding: 10px 0;\n  border-top: solid 1px #f5f5f5;\n  border-bottom: solid 1px #f5f5f5;\n}\n", ""]);

// exports
